"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HEIF_MIME_TYPES = exports.PDF = exports.IMAGES = exports.SPREADSHEETS = void 0;
exports.SPREADSHEETS = [
    { mime: 'text/csv', extension: 'csv' },
    { mime: 'text/plain', extension: 'csv' },
    { mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', extension: 'xlsx' },
    { mime: 'application/vnd.ms-excel', extension: 'xls' },
];
exports.IMAGES = [
    { mime: 'image/jpeg', extension: 'jpg' },
    { mime: 'image/pjpeg', extension: 'jpg' },
    { mime: 'image/png', extension: 'png' },
    { mime: 'image/svg+xml', extension: 'svg' },
    { mime: 'image/heic', extension: 'heic' },
];
exports.PDF = { mime: 'application/pdf', extension: 'pdf' };
exports.HEIF_MIME_TYPES = ['image/heic', 'image/heif'];
//# sourceMappingURL=mime-type.js.map